"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const error_1 = __importDefault(require("@cart/error"));
const provider_1 = require("@cart/provider");
const reopening_1 = __importDefault(require("@cart/reopening"));
const track_1 = require("../../contexts/track");
const hooks_1 = require("../../utils/hooks");
const expired_cart_error_1 = __importDefault(require("../expired-cart-error"));
const frozen_cart_error_1 = __importDefault(require("../frozen-cart-error"));
const incompatible_1 = __importDefault(require("../incompatible"));
const ErrorHandler = ({ open, onClose, isHardChoice, onRouting, addtoCartCallback, store }) => {
    var _a;
    const { data, error, status, statusText, params } = store;
    const { getCartConnected: onReAuth } = (0, provider_1.useCartActions)();
    const { track } = (0, track_1.useTrack)();
    const { i18n } = (0, hooks_1.useTranslate)();
    if (!store || !status || [provider_1.ResponseCode.SUCCESS, provider_1.ResponseCode.CREATED, provider_1.ResponseCode.EMPTY].includes(Number(status)))
        return null;
    switch (status) {
        case provider_1.ResponseCode.EXPIRED:
            return ((0, jsx_runtime_1.jsx)(expired_cart_error_1.default, { open: open, onClose: onClose, data: data, isHardChoice: isHardChoice, onRouting: onRouting, i18n: i18n, track: track }));
        case provider_1.ResponseCode.FROZEN:
            return (0, jsx_runtime_1.jsx)(frozen_cart_error_1.default, { open: open, onClose: onClose, data: data, onRouting: onRouting, i18n: i18n, track: track });
        case provider_1.ResponseCode.REOPEN: {
            const [product] = params;
            if (!product)
                return null;
            const { productId, quantity } = product;
            return ((0, jsx_runtime_1.jsx)(reopening_1.default, { i18n: i18n, ordersToReopen: (_a = data.orders_to_reopen) !== null && _a !== void 0 ? _a : [], productId: productId, quantity: quantity, cartType: data === null || data === void 0 ? void 0 : data.cart_type }));
        }
        case provider_1.ResponseCode.INCOMPATIBLE: {
            const [product, cartType] = params;
            if (!product)
                return null;
            const isLoyalty = typeof cartType !== 'string';
            const { productId: prodId, quantity: qty } = typeof product === 'string' ? { productId: product, quantity: 1 } : product;
            return ((0, jsx_runtime_1.jsx)(incompatible_1.default, { open: open, onClose: onClose, addtoCartCallback: addtoCartCallback, productId: prodId, newLoyalty: !!isLoyalty, quantity: qty, cartType: isLoyalty ? provider_1.CartType.FLASH_SALES : cartType, i18n: i18n, track: track }));
        }
        case provider_1.ResponseCode.MORE_THAN_ONE:
            return null;
        default:
            return ((0, jsx_runtime_1.jsx)(error_1.default, { open: open, onClose: onClose, error: error, status: status, statusText: statusText, onRouting: onRouting, onReAuth: onReAuth, i18n: i18n, track: track }));
    }
};
exports.default = ErrorHandler;
